
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M97 50c0 25.957-21.043 47-47 47S3 75.957 3 50 24.043 3 50 3s47 21.043 47 47z","stroke-width":"6","fill":"none"}}),_c('path',{attrs:{"d":"M32.289 53.463a8.905 8.905 0 100-17.81 8.905 8.905 0 000 17.81zm35.324 0a8.905 8.905 0 100-17.81 8.905 8.905 0 000 17.81zM34.2 63.963c2.694-.29 5.207-.481 7.9-.578 2.693-.096 5.207-.192 7.9-.192 2.693 0 5.207 0 7.9.192a109.3 109.3 0 017.9.578c2.154.288 3.59 1.443 3.051 2.597-.359.866-1.616 1.443-3.052 1.635-2.693.289-5.206.481-7.9.578-2.692.096-5.206.192-7.899.192-2.693 0-5.207 0-7.9-.192a109.033 109.033 0 01-7.9-.578c-2.154-.288-3.59-1.443-3.051-2.597.18-.77 1.436-1.443 3.052-1.635z","data-fill-colored":"true"}})])
          )
        }
      }
    